<template>
  <div>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-office-building
          </v-icon>
          契約者管理
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="6" md="6">
                      <v-text-field v-model="corporateName" clearable persistent-placeholder label="法人名" />
                    </v-col>
                    <v-col cols="6" md="3">
                      <v-select v-model="contractUnitType" :items="contract_unit_types" label="契約種別" hide-details="auto"
                        persistent-placeholder clearable />
                    </v-col>
                    <v-col cols="6" md="3">
                      <v-select v-model="mailSendStatus" :items="mail_send_statuses" label="メール送信" hide-details="auto"
                        persistent-placeholder clearable />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                    &nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <v-row>
      <v-col class="text-left">
        <h4>
          {{ total_count }} 件
        </h4>
      </v-col>
      <v-col class="text-right">
        <v-btn color="info" @click="addButtonClickEvent">
          <v-icon>mdi-plus</v-icon>&nbsp;契約者の追加
        </v-btn>
      </v-col>
    </v-row>

    <!-- 一覧 -->
    <v-row>
      <v-col>
        <v-card class="rounded-card">
          <v-card-text>
            <v-data-table :headers="tableHeaders" :items="contractors" :items-per-page="-1" disable-pagination
              disable-sort hide-default-footer>
              <template v-slot:[`item.code`]="{ item }">
                <span :title="item.code">{{ item.code | truncate(10) }}</span>
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <span :title="item.name">{{ item.name | truncate(18) }}</span>
              </template>
              <template v-slot:[`item.address`]="{ item }">
                <span :title="item.address">{{ item.address | truncate(25) }}</span>
              </template>
              <template v-slot:[`item.supervisor_name`]="{ item }">
                <span :title="item.supervisor_name">{{ item.supervisor_name | truncate(20) }}</span>
              </template>
              <template v-slot:[`item.contract_unit_type_name`]="{ item }">
                <span :title="item.contract_unit_type_name">{{ item.contract_unit_type_name | truncate(20) }}</span>
              </template>
              <template v-slot:[`item.mail_send_at`]="{ item }">
                <span :title="item.mail_send_at">{{ item.mail_send_at }}</span>
              </template>
              <template v-slot:[`item.editable`]="{ item }">
                <v-btn v-if="$vuetify.breakpoint.mdAndUp" icon color="cyan darken-2" @click="showButtonClickEvent(item)">
                  <v-icon>mdi-file-document-outline</v-icon>
                </v-btn>
                <v-btn v-else text color="cyan" @click="showButtonClickEvent(item)">
                  参照する
                </v-btn>
                <v-btn v-if="$vuetify.breakpoint.mdAndUp" color="cyan darken-2" icon @click="editButtonClickEvent(item)">
                  <v-icon>mdi-note-edit</v-icon>
                </v-btn>
                <v-btn v-else text color="cyan" @click="editButtonClickEvent(item)">
                  編集する
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- /一覧 -->

    <!-- ページャ -->
    <v-row v-if="hasResult" dense>
      <v-col>
        <v-pagination v-model="page" :length="pagination.total_pages" :total-visible="totalVisible" circle
          prev-icon="mdi-menu-left" next-icon="mdi-menu-right" @input="changePage" />
      </v-col>
    </v-row>
    <!-- /ページャ -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'AdminContractors',
  components: {},
  mixins: [],
  data() {
    return {
      page: 1,
      totalVisible: 7,
      total_count: null,
      corporateName: null,
      contractUnitType: null,
      mailSendStatus: null,
      tableHeaders: [
        { value: 'code', text: '法人コード' },
        { value: 'name', text: '法人名' },
        { value: 'address', text: '住所' },
        { value: 'phone_number', text: '電話番号' },
        { value: 'supervisor_name', text: '担当者' },
        { value: 'contract_unit_type_name', text: '契約単位' },
        { value: 'mail_send_at', text: 'メール送信日時' },
        { value: 'editable', text: '', align: 'end' },
      ],
      contractors: [],
      contract_unit_types: [],
      mail_send_statuses: [],
    }
  },
  computed: {
    ...mapState('AdminContractor', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('AdminContractor', [
      'hasResult'
    ]),
  },
  watch: {
    corporateName(newVal) {
      this.saveCondition({ name: newVal })
    },
    contractUnitType(newVal) {
      this.saveCondition({ contract_unit_type: newVal })
    },
    mailSendStatus(newVal) {
      this.saveCondition({ mail_send_status: newVal })
    },
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetCondition()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.corporateName = this.searchCondition.name
    this.contractUnitType = this.searchCondition.contract_unit_type
    this.mailSendStatus = this.searchCondition.mail_send_status
    this.page = this.pagination.current_page
    this.searchContractor()
  },
  methods: {
    ...mapActions('AdminContractor', {
      fetchContractors: 'index',
      saveCondition: 'saveCondition',
      resetCondition: 'resetState',
      resetPagination: 'resetPagination',
    }),
    /**
     * 契約者追加ボタン クリックイベント
     */
    addButtonClickEvent() {
      this.$router.push({ name: 'AdminContractorNew' })
    },
    /**
     * 契約者参照ボタン クリックイベント
     */
    showButtonClickEvent(item) {
      this.$router.push({ name: 'AdminContractor', params: { id: item.id } })
    },
    /**
     * 契約者編集ボタン クリックイベント
     */
    editButtonClickEvent(item) {
      this.$router.push({ name: 'AdminContractorEdit', params: { id: item.id } })
    },
    /**
     * 契約者検索ボタン クリックイベント
     */
    searchButtonClickEvent() {
      this.page = 1
      this.searchContractor()
    },
    changePage() {
      this.searchContractor()
    },
    searchContractor() {
      let params = {
        name: this.corporateName,
        contract_unit_type: this.contractUnitType,
        mail_send_status: this.mailSendStatus,
        page: this.page
      }
      this.fetchContractors(params).then((content) => {
        this.contractors = content.contractors
        this.total_count = content.pagination.total_count
        this.contract_unit_types = content.contract_unit_types
        this.mail_send_statuses = content.mail_send_statuses
      })
    }
  }
}
</script>

<style scoped lang="scss">
.panel-header-color {
  color: #0D74BA !important;

  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;

      &::before {
        color: #0D74BA !important;
      }
    }
  }
}

.panel-selectable {
  background-color: #DCE7EB;
}
</style>
